import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Marker, Polyline, Tooltip } from "react-leaflet";
import Leaflet from "leaflet";
import { convertPositions } from '../../../utils/helpers';
import guid from './../../../utils/guid';
import moment from 'moment-timezone';
import t from "../../../languages/pl";
import { displayDateTimeFormat } from '../../../utils/staticData';
import finishRoutePin from "../../../images/mapPins/finishRoutePin.png";
import startRoutePin from "../../../images/mapPins/startRoutePin.png";
import { getAddress } from '../../../requests/mapRequests';

const startIcon = new Leaflet.icon({
    iconUrl: startRoutePin,
    iconSize: [50, 50],
    iconAnchor: [25, 50]
});

const finishIcon = new Leaflet.icon({
    iconUrl: finishRoutePin,
    iconSize: [50, 50],
    iconAnchor: [25, 50]
});

const standardSpeedColor = {
    color: "#a3469e",
    weight: 5,
};

const speedExceededColor = {
    color: "#f4853f",
    weight: 5,
};

const speedExceededAbove30Color = {
    color: "#ff0000",
    weight: 5,
};

const speedExceededAbove50Color = {
    color: "#000000",
    weight: 5,
};

const selectStyle = (speedLimit, speed) => {
    if (speedLimit === -1 || speed < speedLimit)
        return standardSpeedColor;

    if (speed >= speedLimit + 10 && speed <= speedLimit + 30)
        return speedExceededColor;

    if (speed > speedLimit + 30 && speed <= speedLimit + 50)
        return speedExceededAbove30Color;

    if (speed > speedLimit + 50)
        return speedExceededAbove50Color;

    return standardSpeedColor;
};

const CurrentSingleRoute = props => {
    const { route } = props;
    const [startAddressSearching, setStartAddressSearching] = useState(false);

    const revealStartAddress = (id, point) => {
        if (point.adres === null && !startAddressSearching) {
            getAddress(point, (response) => props.updateStartAddress(id, response.data.adres));
            setStartAddressSearching(true);
        }
    };

    const printPolylines = () => {
        return route.map((routePart, index) => {
            if (route && index < route.length - 1) {
                return (
                    <Polyline
                        key={guid()}
                        positions={convertPositions([routePart, route[index + 1]])}
                        {...selectStyle(routePart.predkosc_dopuszczalna, routePart.predkosc)}
                    >
                        <Tooltip
                            direction="top"
                            className="toyotaFont"
                            sticky
                        >
                            {t.currentRoute}
                            <br />
                            {t.from + ': '} {moment.unix(route[0].data_od).format(displayDateTimeFormat)}
                            <br />
                            {routePart.predkosc_dopuszczalna !== -1 && routePart.predkosc >= routePart.predkosc_dopuszczalna + 10
                                ?
                                <Fragment>
                                    {t.speedLimit} {routePart.predkosc_dopuszczalna}  km/h.
                                    <br />
                                    {t.speedWhenCrossing}  {routePart.predkosc}  km/h.
                                    <br />
                                    {t.speedExceededBy} {routePart.predkosc - routePart.predkosc_dopuszczalna} km/h
                                </Fragment>
                                : null}
                        </Tooltip>
                    </Polyline>
                );
            }
        });
    };

    return (
        <React.Fragment>
            {printPolylines()}
            {route[0] && <Marker
                position={convertPositions(route[0])}
                icon={startIcon}
            >
                <Tooltip
                    direction="top"
                    className="toyotaFont"
                    offset={new Leaflet.point(0, -50)}
                    //onOpen={() => revealStartAddress(route.id, route[0])}
                >
                    {t.routeBegin}
                    <br />
                    {t.date}: {moment.unix(route[0].data_od).format(displayDateTimeFormat)}
                    <br />
                    {t.meterReading}: {route[0].dystans_przed} km
                            <br />
                    {t.fuelLevel}:&nbsp;
                            {route[0].stan_paliwa_przed} l ({Math.round(route[0].stan_paliwa_procent_przed * 100)}%)
                            <br />
                    {route[0].adres ? route[0].adres : "Szukam adresu..."}
                </Tooltip>
            </Marker>}
        </React.Fragment>
    );
};

CurrentSingleRoute.propTypes = {
    route: PropTypes.array,
    updateStartAddress: PropTypes.func,
    updateEndAddress: PropTypes.func
};

export default CurrentSingleRoute;
